import controller from './client-add-modal-controller';
import template from './client-add-modal.html';

const clientAddModalComponent = {
    bindings: {
        modalInstance: '<',
        resolve: '<'
    },
    controller,
    template
};

export default clientAddModalComponent;



// WEBPACK FOOTER //
// ./app/components/client-admin/client-add-modal/client-add-component.js